import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: true,
  fornitori: [],
  categorie: [],
  metodiPagamento: [],
};

const notaSpeseSlice = createSlice({
  name: 'notaSpese',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaFornitori(state, action) {
      state.fornitori = action.payload;
    },
    aggiornaCategorie(state, action) {
      state.categorie = action.payload;
    },
    aggiornaMetodiPagamento(state, action) {
      state.metodiPagamento = action.payload;
    },
  },
});

export const { caricamento, aggiornaFornitori, aggiornaCategorie, aggiornaMetodiPagamento } = notaSpeseSlice.actions;
const { reducer } = notaSpeseSlice;

export default reducer;
